<script lang="ts">
  import { AppState } from '../../etc/stores';
  import flagKeys from '../../etc/flagKeys';
  const { primary, primary500, typography } = $AppState.theme.colors;
  const { secondary, primary: primaryIlustration } =
    $AppState.theme.colors.illustration;
</script>

<svg
  width="88"
  height="88"
  viewBox="0 0 88 88"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  {#if $AppState.featureFlags.includes(flagKeys.NEW_COIN_ICON)}
    <circle cx="44" cy="44" r="44" fill="url(#paint0_linear_850_5274)" />
    <path
      d="M62.6663 32.402L62.6663 32.396C62.6663 27.2067 54.309 23 43.9997 23C33.6904 23 25.333 27.2067 25.333 32.396C25.333 37.5852 33.6904 41.792 43.9997 41.792C54.305 41.792 62.6598 37.5885 62.6663 32.402Z"
      fill="url(#paint1_linear_850_5274)"
    />
    <path
      d="M25.333 32.396V44.9183C25.333 50.108 33.6895 54.3143 43.9997 54.3143C54.3099 54.3143 62.6663 50.108 62.6663 44.9183V32.402C62.6598 37.5885 54.305 41.792 43.9997 41.792C33.6904 41.792 25.333 37.5852 25.333 32.396Z"
      fill="url(#paint2_linear_850_5274)"
    />
    <path
      d="M43.9997 54.3143C33.6895 54.3143 25.333 50.108 25.333 44.9183V57.4463C25.333 62.636 33.6895 66.8423 43.9997 66.8423C54.3099 66.8423 62.6663 62.636 62.6663 57.4463V44.9183C62.6663 50.108 54.3099 54.3143 43.9997 54.3143Z"
      fill="url(#paint3_linear_850_5274)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.6663 32.3903C62.6657 31.8817 62.5849 31.3826 62.4298 30.896C61.003 26.4197 53.2947 23 43.9997 23C34.7046 23 26.9963 26.4197 25.5696 30.896C25.4145 31.3826 25.3336 31.8817 25.333 32.3903C25.333 32.3922 25.333 32.3941 25.333 32.396V57.4463C25.333 62.636 33.6895 66.8423 43.9997 66.8423C54.3099 66.8423 62.6663 62.636 62.6663 57.4463L62.6663 32.396C62.6663 32.3941 62.6663 32.3922 62.6663 32.3903ZM59.6663 32.396C59.6663 31.5393 58.9019 29.9678 55.8502 28.4317C52.9723 26.9831 48.7868 26 43.9997 26C39.2126 26 35.0271 26.9831 32.1492 28.4317C29.0975 29.9678 28.333 31.5393 28.333 32.396V35.5122C29.08 36.2735 30.1182 37.0173 31.4748 37.7001C34.6027 39.2746 39.0288 40.292 43.9997 40.292C48.9686 40.292 53.3932 39.2754 56.521 37.7019C57.8792 37.0186 58.9187 36.2742 59.6663 35.5122L59.6663 32.396ZM59.6663 39.3463C59.0993 39.7206 58.4966 40.0663 57.8691 40.3819C54.2415 42.2068 49.3361 43.292 43.9997 43.292C38.6612 43.292 33.754 42.206 30.1259 40.3798C29.5 40.0647 28.8988 39.7198 28.333 39.3463V48.0349C29.0799 48.7961 30.118 49.5398 31.4744 50.2226C34.6022 51.797 39.0283 52.8143 43.9997 52.8143C48.9711 52.8143 53.3971 51.797 56.5249 50.2226C57.8813 49.5398 58.9194 48.7961 59.6663 48.0349V39.3463ZM59.6663 51.869C59.1007 52.2424 58.4996 52.5872 57.8738 52.9022C54.2458 54.7284 49.3385 55.8143 43.9997 55.8143C38.6608 55.8143 33.7536 54.7284 30.1256 52.9022C29.4998 52.5872 28.8987 52.2424 28.333 51.869V57.4463C28.333 58.3034 29.0975 59.8748 32.1488 61.4107C35.0266 62.8593 39.212 63.8423 43.9997 63.8423C48.7873 63.8423 52.9728 62.8593 55.8505 61.4107C58.9018 59.8748 59.6663 58.3034 59.6663 57.4463V51.869Z"
      fill="url(#paint4_linear_850_5274)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_850_5274"
        x1="44"
        y1="0"
        x2="44"
        y2="88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={primary500} />
        <stop offset="1" stop-color={primary500} stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_850_5274"
        x1="55.2249"
        y1="-33.6296"
        x2="17.5742"
        y2="-30.0962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={secondary} />
        <stop offset="1" stop-color={primaryIlustration} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_850_5274"
        x1="55.2249"
        y1="-33.6296"
        x2="17.5742"
        y2="-30.0962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={secondary} />
        <stop offset="1" stop-color={primaryIlustration} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_850_5274"
        x1="55.2249"
        y1="-33.6296"
        x2="17.5742"
        y2="-30.0962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={secondary} />
        <stop offset="1" stop-color={primaryIlustration} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_850_5274"
        x1="15.999"
        y1="16.5"
        x2="71.499"
        y2="72.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.109375" stop-color={typography} />
        <stop offset="1" stop-color={typography} stop-opacity="0" />
      </linearGradient>
    </defs>
  {:else}
    <circle cx="44" cy="44" r="44" fill="url(#paint0_linear_2629_15530)" />
    <circle
      cx="43.665"
      cy="43.665"
      r="26.665"
      fill="url(#paint1_linear_2629_15530)"
    />
    <path
      d="M43.6655 28.8511L47.8555 39.475L58.4793 43.665L47.8555 47.855L43.6655 58.4789L39.4755 47.855L28.8516 43.665L39.4755 39.475L43.6655 28.8511Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2629_15530"
        x1="44"
        y1="0"
        x2="44"
        y2="88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={primary500} />
        <stop offset="1" stop-color={primary500} stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2629_15530"
        x1="59.7"
        y1="-51.8846"
        x2="6.09403"
        y2="-45.9768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={primary} />
        <stop offset="1" stop-color={secondary} />
      </linearGradient>
    </defs>
  {/if}
</svg>
